<mat-sidenav-container fullscreen>
	<mat-menu #menu="matMenu">
		<mat-nav-list>
			<button mat-menu-item routerLink="/home" routerLinkActive="active-route">
				<mat-icon mat-list-icon>home</mat-icon>
				<span matLine>Inicial</span>
			</button>
			<mat-divider></mat-divider>
			<button mat-menu-item routerLink="/lista-cotacoes" routerLinkActive="active-route">
				<mat-icon mat-list-icon>assignment</mat-icon>
				<span matLine>Cotações</span>
			</button>
			<mat-divider></mat-divider>
			<button mat-menu-item (click)="logout()">
				<mat-icon mat-list-icon>exit_to_app</mat-icon>
				<span matLine>Logout</span>
			</button>
		</mat-nav-list>
	</mat-menu>
	<mat-toolbar color="primary">
		<button mat-icon-button style="margin-right: 25px;" [matMenuTriggerFor]="menu">
			<mat-icon>menu</mat-icon>
		</button>
		<span class="app-fill-remaining-space"></span>
		<img id="clienteImage" src="assets/images/sua_logo.png" class="logo-filial" alt="Avatar" />
		<img src="assets/images/favicon.png" class="logo-filial" alt="Avatar" />
	</mat-toolbar>

	<div class="middle-layer">
		<div class="app-content" layout="column" [ngStyle]="appContentStyle">
			<meta charset="utf-8" />
			<mat-toolbar class="toolbar" id="topo">
				<div>
					Cotação {{solicitacao.nrSolicitacao}}
					<span></span>
				</div>
				<div>
					<mat-form-field>
						<input autofocus type="search" matInput name="search" placeholder="Pesquisar"
							(input)="solicitacao.filtraItens(search.value)" #search>
					</mat-form-field>
				</div>
			</mat-toolbar>

			<form class="background-color" *ngIf="solicitacao.loadSuccess" (ngSubmit)="salvar()"
				(keydown.enter)="$event.preventDefault()">				
				<div class="list custom-max-width">
					<div class="custom-toolbar-header cabecalho">
						<div class="ajuste-largura-relativa-100">
							<div class="item-header">
								<div class="ajuste-largura-relativa-100">Código</div>
							</div>
							<div  class="esconder-3 item-header">
								<div class="ajuste-largura-relativa-100">Cd. Fabricante</div>
							</div>
							<div  class="esconder-1 item-header">
								<div class="ajuste-largura-relativa-100">Descrição</div>
							</div>
							<div  class="esconder-1 item-header">
								<div class="ajuste-largura-relativa-100">Marca</div>
							</div>
							<div  class="esconder-1 item-header">
								<div class="ajuste-largura-relativa-100">NCM</div>
							</div>
							<div  class="item-header">
								<div class="ajuste-largura-relativa-100">Qtde.</div>
							</div>
							<div class="esconder-2 item-header" style="margin-right: 25px ;">
								<div class="ajuste-largura-relativa-100">Cod. Fornecedor</div>
							</div>	
						</div>
					</div>					

					<div class="item"
						*ngFor="let cot of solicitacao.itensFiltro | paginate: { itemsPerPage: 15, currentPage: page }">
						<app-item-cotacao #itemCotacao [cot]="cot" [mostrarCdFabricante]="true"
							[unMedida]="solicitacao.getUnMedida(cot)" [cdProdutoForn]="solicitacao.getCdProdForn(cot)"
							[filiais]="solicitacao.filiais" [allExpandState]="allExpandState"
							(recalcularCallback)="recebeFeedback($event)"
							(salvarCallback)="recebeFeedbackSalvar($event)"></app-item-cotacao>
					</div>
				</div>

				<div class="align-text-center">
					<pagination-controls (pageChange)="page=$event" nextLabel="Próximo" previousLabel="Anterior">
					</pagination-controls>
				</div>

				<div class="item-espaco">
					<div [ngClass]="{'custom-toolbar sombra custom-max-width': true}">
						<div [ngClass]="{'custom-toolbar-header': true}">
							Cotação {{solicitacao.nrSolicitacao}}
						</div>
						<div [ngClass]="{'custom-toolbar-body': true}">
							<div class="list">
								<div class="item">
									<div class="line">
										<form [formGroup]="formulario">
											<mat-form-field>
												<mat-label>Data Validade</mat-label>
												<!--Remover todos os ngModels????-->
												<input matInput [(ngModel)]="solicitacao.cotacao.dtValidade"
													name="dtValidade" formControlName="dataValidade"
													(input)="formatarDataValidade($event.target.value)">
												<mat-error *ngIf="formulario.get('dataValidade').hasError('required') && formulario.get('dataValidade').touched">
												A data de validade é obrigatória.
												</mat-error>
												<mat-error *ngIf="formulario.get('dataValidade').hasError('dataInvalida')">Data inválida.</mat-error> 
											</mat-form-field>
										</form>
										<form [formGroup]="formulario">
											<mat-form-field>
												<mat-label>Dt. Faturamento</mat-label>
												<input matInput [(ngModel)]="solicitacao.cotacao.dtFaturamento"
													name="dtFaturamento" formControlName="dataFaturamento"
													(input)="formatarDataFaturamento($event.target.value)">
													<mat-error *ngIf="formulario.get('dataFaturamento').hasError('required') && formulario.get('dataFaturamento').touched">
														A data de faturamento é obrigatória.
													</mat-error>
													<mat-error *ngIf="formulario.get('dataFaturamento').hasError('dataInvalida')">Data inválida.</mat-error> 
											</mat-form-field>
										</form>
										<mat-form-field class="field-prev-entrega">
											<mat-label>Previsão de entrega</mat-label>
											<input matInput [(ngModel)]="solicitacao.cotacao.diasPrevEntrega"
											(blur)="atualizarDtPrevEntregaItens()"
												name="prevEntrega" type="number" min="0">
											<span matSuffix>dias</span>
										</mat-form-field>
										<form [formGroup]="formulario">
											<mat-form-field>
												<mat-label>Dt.Prev.Entrega padrão</mat-label>
												<input matInput name="dtPrevEntregaPadrao" formControlName="dtPrevEntregaPadrao"
													(input)="formatarDtPrevEntregaPadrao($event.target.value)"
													(blur)="aplicarDtPrevEntregaPadraoAosItens()">
												<mat-error *ngIf="formulario.get('dtPrevEntregaPadrao').hasError('dateNotValid')">Data inválida.</mat-error>
											</mat-form-field>
										</form>
										<mat-form-field class="field-prazo-pgto">
											<mat-label>Prazo de Pagamento</mat-label>
											<input matInput [(ngModel)]="solicitacao.cotacao.prazoPagamento"
												name="prazoPgto" maxlength="30">
										</mat-form-field>
										<form [formGroup]="formulario">
											<mat-form-field class="field-tipo-frete">
												<mat-label>Tipo Frete</mat-label>
												<mat-select id="selectTipoFrete" [(ngModel)]="solicitacao.cotacao.tpFrete" 
												name="tpFrete" class="select-tipo-frete" formControlName="tipoFrete" required>
													<mat-option *ngFor="let tpFrete of tiposDeFrete" [value]="tpFrete">{{ tpFrete }}</mat-option>
												</mat-select>
												<mat-error *ngIf="formulario.get('tipoFrete').hasError('required')">O tipo de frete é obrigatório.</mat-error>
											</mat-form-field>
										</form>
										<mat-form-field class="field-valor">
											<mat-label>Frete</mat-label>
											<input matInput [(ngModel)]="solicitacao.cotacao.vlFrete" (ngModelChange)="solicitacao.recalculaVlTotalComParcelas()"
												(input)="solicitacao.recalculaVlTotalComParcelas()" type="number"
												name="vlFrete">
											<span matPrefix>R$&nbsp;</span>
										</mat-form-field>
										<mat-form-field class="field-valor">
											<mat-label>Valor Total</mat-label>
											<input matInput [ngModel]="solicitacao.cotacao.vlTotal?.toFixed(2)"
												name="vlTotal" disabled>
											<span matPrefix>R$&nbsp;</span>
										</mat-form-field>
										<div class="list" style="width: 1600px;">
											<form [formGroup]="formulario">
												<div class="list line">
													
														<mat-form-field class="field-parcela">
															<mat-label>Data Inicial do Pagamento</mat-label>
															<input matInput formControlName="dataInicial" (input)="formatarDataInicialPgto($event.target.value)">
															<mat-error *ngIf="formulario.get('dataInicial').hasError('required')">A data inicial é obrigatória.</mat-error>
															<mat-error *ngIf="formulario.get('dataInicial').hasError('dataInvalida')">A data inválida.</mat-error>    
														</mat-form-field>
													
													
														<mat-form-field class="field-parcela">
															<mat-label>Número de Parcelas</mat-label>    
															<input matInput type="text" formControlName="numeroParcelas" pattern="[0-9]*[.]?[0-9]+" inputmode="numeric">
															<mat-error *ngIf="formulario.get('numeroParcelas').errors?.min">Número de parcelas deve ser no mínimo 1.</mat-error>
															<mat-error *ngIf="formulario.get('numeroParcelas').errors?.pattern">Informe apenas números.</mat-error>
														</mat-form-field>
													
												
														<mat-form-field class="field-parcela" *ngIf="!mensal">
															<mat-label	mat-label>Intervalo em Dias</mat-label>    
															<input matInput type="text" formControlName="intervaloEmDias" pattern="[0-9]*[.]?[0-9]+" inputmode="numeric">
															<mat-error *ngIf="formulario.get('intervaloEmDias').errors?.min">Intervalo deve ser no mínimo 1 dia.</mat-error>    
															<mat-error *ngIf="formulario.get('intervaloEmDias').errors?.pattern">Informe apenas números.</mat-error>
														</mat-form-field>
													
													<div class="field-parcela-checkbox" >
														<mat-checkbox formControlName="mensal" (change)="changeCheckbox()">Mensal</mat-checkbox>

													</div>
													<div class="field-parcela-button">
														<button  mat-raised-button [disabled]="validarCamposParcela()" (click)="openDialogCalcularProjecao()">Calcular Projeção</button>
													</div>
													<div class="field-parcela-button">
														<button  mat-raised-button [disabled]="habilitarExclusaoDeParcelas()" (click)="openDialogExcluirParcelas()">Limpar Parcelas</button>
													</div>
												</div>
											</form>
										</div>
										
										<div *ngIf="datasPagamentoComBarra.length > 0 && solicitacao.cotacao.parcelas.length > 0">
											<div class="table-wrapper">
												<h3>Projeção de Pagamento</h3>
												<table>
													<thead>
														<tr>
														<th>Data de Pagamento</th>
														<th>Valor da Parcela</th>
														</tr>
													</thead>
													<tbody>
														<tr *ngFor="let data of datasPagamento; let i = index">
															<td>
																<mat-form-field class="width-100">
																	<mat-label>Data de Pagamento</mat-label>            
																	<input matInput type="text" [(ngModel)]="datasPagamentoComBarra[i]" (input)="formatarDataParcela($event.target.value, i)" [ngModelOptions]="{standalone: true}" >
																</mat-form-field>
															</td>
															<td>
																<mat-form-field class="width-100">
																	<mat-label>Valor da Parcela</mat-label>
																	<input matInput type="text" [(ngModel)]="valoresParcelas[i]" (ngModelChange)="atualizaVlPristino()" (input)="setParcelas()" [ngModelOptions]="{standalone: true}" inputmode="numeric">        
																	<span matPrefix>R$&nbsp;</span>
																</mat-form-field>
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
										<div *ngIf="solicitacao.possuiParcelas && datasPagamentoComBarra.length <= 0">
											<div class="table-wrapper">
												<h3>Parcelas</h3>
												<table>
													<thead>
														<tr>
														<th>Data de Pagamento</th>
														<th>Valor da Parcela</th>
														</tr>
													</thead>
													<tbody>
														<tr *ngFor="let parcela of solicitacao.cotacao.parcelas; let i = index">
														<td>
															<mat-form-field class="width-100">
																<mat-label>Data de Pagamento</mat-label>            
																<input matInput [(ngModel)]="solicitacao.cotacao.parcelas[i].dtVctoFormatada" (input)="formatarDataVcto($event.target.value, i)"  [ngModelOptions]="{standalone: true}">
															</mat-form-field>
														</td>
														<td>
															<mat-form-field class="width-100">
																<mat-label>Valor da Parcela</mat-label>
																<input matInput type="text" [(ngModel)]="solicitacao.cotacao.parcelas[i].vlVcto" (ngModelChange)="atualizaVlPristino()" [ngModelOptions]="{standalone: true}" inputmode="numeric">  
																<span matPrefix>R$&nbsp;</span>      
															</mat-form-field>
														</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
										
									</div>
								</div>
							</div>
						</div>
					</div>
				</div> 


				<div class="buttons" id="btnSalvar">
					<button type="submit" mat-raised-button>SALVAR</button>
					<button type="submit" class="ml-5" mat-raised-button color="primary"
						(click)="finalizar()">FINALIZAR</button>
				</div>
			</form>
		</div>
		<div class="estilo-menu">
			<mat-grid-list style="position: relative; height: 100%;" rows="20" cols="1" rowHeight="22px">
				<mat-grid-tile [rowspan]="2">
					<span class="expandir-mais">
						<button mat-mini-fab color="primary" mat-elevation-z4 (click)="allExpandState = true">
							<mat-icon>unfold_more</mat-icon>
						</button>
					</span>
				</mat-grid-tile>
				<mat-grid-tile [rowspan]="2">
					<span class="expandir-menos">
						<button mat-mini-fab color="primary" mat-elevation-z4 (click)="allExpandState = false">
							<mat-icon>unfold_less</mat-icon>
						</button>
					</span>
				</mat-grid-tile>
				<mat-grid-tile [rowspan]="4">
					<button class="ordenar" mat-mini-fab color="primary" (click)="showOl=!showOl">
						<mat-icon>reorder</mat-icon>
					</button>
				</mat-grid-tile>
				<mat-grid-tile [rowspan]="2">
					<span [ngClass]="{'inicio':true}">
						<button mat-mini-fab color="primary" mat-elevation-z4 id="goUpButton"
							(click)="solicitacao.scroll('topo')">
							<mat-icon>expand_less</mat-icon>
						</button>
					</span>
				</mat-grid-tile>
				<mat-grid-tile [rowspan]="2">
					<span [ngClass]="{'final':true}">
						<button mat-mini-fab color="primary" mat-elevation-z4 id="goDownButton"
							(click)="solicitacao.scroll('btnSalvar')">
							<mat-icon>expand_more</mat-icon>
						</button>
					</span>
				</mat-grid-tile>
			</mat-grid-list>
		</div>

		<form name="navForm">
			<div class="search-nav" layout="row" layout-align="center center" [ngStyle]="olStyle">
				<div class="disabled" (click)="showOl=!showOl"></div>
				<mat-card class="orderlist-margin">
					<mat-card-header class="flex-center" fxLayoutAlign="center">
						<mat-card-title>Ordenar cotações</mat-card-title>
					</mat-card-header>
					<mat-divider></mat-divider>

					<mat-card-content  class="custom-padding" >
						<!-- <mat-chip-list></mat-chip-list> -->

						<mat-card-subtitle class="mat-card-content-orderlist" fxLayoutAlign="center"
							*ngIf="ol.listaEscolhido.length===0">Adicione para ordenar</mat-card-subtitle>

						<mat-grid-list class="custom-margin-remove"  *ngIf="ol.listaEscolhido.length > 0" cols="1"
							rowHeight="30px">
							<mat-grid-tile *ngFor="let op of ol.listaEscolhido">
								<mat-chip [removable]="ol.removable" (removed)="ol.remove(op); ordena()">
								{{op}}
								<mat-icon style="color: #ff3300;" matChipRemove *ngIf="ol.removable">cancel</mat-icon>
							</mat-chip>
							</mat-grid-tile>
						</mat-grid-list>

						<mat-divider></mat-divider>

						<mat-grid-list  class="custom-margin-add" cols="1" rowHeight="30px">
							<mat-grid-tile *ngFor="let op of ol.listaDisponivel">
								<mat-chip [removable]="ol.removable" (removed)="ol.add(op); ordena()">
								{{op}}
								<mat-icon style="color: #08972b;" matChipRemove *ngIf="ol.removable">add_circle</mat-icon>
							</mat-chip>
							</mat-grid-tile>
						</mat-grid-list>
					</mat-card-content>
				</mat-card>
			</div>
		</form>
	</div>
</mat-sidenav-container>